<template>
    <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="0px" class="loginForm">
      <h3>登录系统</h3>
      <el-form-item label=""  prop="userName" size="small">
        <el-input v-model="ruleForm.userName" placeholder="请输入用户名称" prefix-icon="el-icon-user-solid"></el-input>
      </el-form-item>
      <el-form-item label=""  prop="pass" size="small">
        <el-input  type="password" v-model="ruleForm.pass" autocomplete="off" placeholder="请输入登录密码" prefix-icon="el-icon-lock" :show-password="true"></el-input>
      </el-form-item>
      <el-form-item class="codeItem" prop="checkCode" size="small">
        <el-input
            v-model.number="ruleForm.checkCode"
            autocomplete="off" maxlength="6"
            class="codeInput"
            oninput="value=value.replace(/[^\d]/g,'')"
            placeholder="验证码"
            prefix-icon="el-icon-s-check"></el-input >
        <el-button type="primary" @click="getCode" class="codeBtn"><span  style="font-size: 14px!important;">获取验证码</span></el-button>
      </el-form-item>
      <div class="error" v-if="!data.status">{{data.msg}}</div>
      <el-form-item >
        <el-button class="loginBtn"
                   type="primary"
                   @click="login('ruleForm')">
            <span class="button_text">登&nbsp;&nbsp;&nbsp;录</span>
        </el-button>
      </el-form-item>
      <div class="regist"><span>如果没有账号，请先<el-link :underline="false" @click.prevent="$emit('changePage');">注册账号</el-link></span></div>
    </el-form>
</template>

<script>
  import {mapMutations} from "vuex";
  import {Loading, Message} from "element-ui";

  export default {
    name: "login",
    data() {
      return {
        ruleForm: {
          userName: '',
          pass: '',
          checkCode:'',
        },
        rules: {
          pass: [
            { required:true ,message:'密码不能为空', trigger: 'blur' }
          ],
          userName: [
            { required:true ,message:'用户名不能为空', trigger: 'blur' }
          ],
          checkCode: [
            { required:true ,message:'请输入验证码', trigger: 'blur' }
          ]
        },
        data:{
          status:true,
          msg:''
        },
        btnClick:false
      };
    },
    methods: {
      login(formName) {
        this.$refs[formName].validate(async (valid,object) => {
          if (valid) {
            const lockScreen = Loading.service({
              lock: true,
              text: '登录中',
              background: 'rgba(0, 0, 0 ,0.2)'
            });
            const result = await this.$api.checkCheckCode(this.ruleForm.userName,null,this.ruleForm.checkCode);
            if (result){
              const res = await this.$api.login(this.ruleForm.userName, this.ruleForm.pass);
              if (res.token) {
                localStorage.removeItem('token');
                localStorage.setItem('token', `${res['token_type']} ${res.token}`);
                localStorage.setItem('username', this.ruleForm.userName);
                this.resetForm(formName);
                this.toPage('/navigation');
              }else {//登录失败
                Message({message:res.msg,type:"error"});
              }
            }else{
              this.$set(this.ruleForm,'checkCode','');
              Message({message:'验证码输入有误！',type:"error"});
            }
            lockScreen.close();
          } else {
            console.log(object);
          }
        });
      },
      getCode(){
        this.$api.getCheckCode(this.ruleForm.userName,null);
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
      ...mapMutations([//将Vuex中的方法映射在此
          'toPage'
      ]),
    },
  }
</script>

<style scoped>
  span{
    font-size:14px;
    font-family: 'Arial Normal', 'Arial', sans-serif;
  }
  h3{
    font-family: "微软雅黑 Bold", 微软雅黑, sans-serif;
    font-weight: 700;
    font-style: normal;
    font-size: 24px;
    color:rgba(101, 121, 155,.9);
    line-height: 28px;
    text-align: center;
    margin-top: 1px;
  }
  .el-input{
    color: rgb(26, 188, 156);
    display: inline-block;
    padding: 0;
    width: 220px;
  }
  .loginBtn{
    margin-top: 5px;
    width: 20rem;
    height: 4.3rem;
    backdrop-filter: blur(2px);
    background:linear-gradient(135deg,rgba(83, 105, 118,.8),rgba(41, 46, 73,.8));
    box-shadow: 0 2px 3px rgba(83, 105, 118,.4);
    border: none;
    border-radius: 12px;
  }
  .loginBtn:hover{
    color: rgb(105, 195, 207);
    box-shadow: 0 0 8px rgba(101, 121, 155,.9);
  }
  .button_text{
    font-family: 微软雅黑, sans-serif;
    font-weight: 500;
    font-size: 16px;
    font-style: normal;
    color: rgb(167, 220, 227);
  }
  .regist{
    text-align: right;
    margin-right:-10rem;
    margin-top: 2rem;
  }
  .el-form-item{
    margin: 2rem 3rem 0;
  }
  .el-form{
    position: absolute;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 20%;
    height: 41.5rem;
    width: 34rem;
    padding: 8.7rem 0;
    border-radius: 16px;
    backdrop-filter: blur(2rem);
    background: linear-gradient(to right top,rgba(255,255,255,.76),rgba(255,255,255,.4));
    box-shadow: 0 2px 2px 0 rgba(255, 255, 255, 0.3), 0 5px 5px 0 rgba(255, 255, 255, .2);
  }
  .error{
    font-size: 13px;
    color: #fe1b52;
    height: fit-content;
    margin-left: 4rem ;
    margin-top: 10px;
    z-index: 999;
  }
  .codeItem{
    position: relative;
    display: flex;
  }
  .codeInput{
    width: 100px;
    position: relative;
    left: -9px;
  }
  .codeBtn{
    position: relative;
    font-size: 8px;
    width: 90px;
    padding: 10px 9px;
    top: 1px;
    border-radius: 12px;
    right: -11px;
    color: rgba(207, 216, 220,.95);
    background: rgba(87, 123, 140,.9);
    border: none;
  }
  .codeBtn:hover{
    background: #425d70;
  }
</style>
